import { all, take, select } from 'redux-saga/effects';
import { SET_PARAM_AMS_SEGMENTS } from '@corefront/redux-aba';
import {
  AMSRefreshHoursSelector,
  isAMSEnabledSelector,
} from '../../reducers/app/configuration';
import {
  AMSSegmentsSelector,
  isLoggedInSelector,
  userNumberSelector,
} from '../../reducers/app/params';
import {
  getSegmentsDataKey,
  getUserSegmentsData,
} from '../../../utils/segments';
import { SET_COMMON_CONFIGURATION } from '../../constants/configuration';

const HOUR_IN_MS = 1000 * 60 * 60;

export function* orderingWatcher() {
  yield all([take(SET_PARAM_AMS_SEGMENTS), take(SET_COMMON_CONFIGURATION)]);
  const isAMSEnabled: ReturnType<typeof isAMSEnabledSelector> = yield select(
    isAMSEnabledSelector
  );
  const isLoggedIn: ReturnType<typeof isLoggedInSelector> = yield select(
    isLoggedInSelector
  );

  if (isAMSEnabled && isLoggedIn) {
    const userNumber: ReturnType<typeof userNumberSelector> = yield select(
      userNumberSelector
    );
    const lcKey = getSegmentsDataKey(userNumber);
    const segmentsData = getUserSegmentsData(lcKey);

    // if in use - check time, if no - just write it
    const refreshTimeInterval: ReturnType<typeof AMSRefreshHoursSelector> =
      yield select(AMSRefreshHoursSelector);

    if (
      Date.now() - segmentsData?.timestamp >
      refreshTimeInterval * HOUR_IN_MS
    ) {
      const segments: ReturnType<typeof AMSSegmentsSelector> = yield select(
        AMSSegmentsSelector
      );
      segmentsData.segments = segments;
      segmentsData.timestamp = Date.now();
      localStorage.setItem(lcKey, JSON.stringify(segmentsData));
    }
  }
}
